import { useState, useEffect } from "react";
import GeneralInfoService from "../Services/GeneralInfoService";

export const useFullName = (username?: string) => {
  const [fullName, setFullName] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(Boolean(username));
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    if (!username) {
      setFullName("Guest User");
      setIsLoading(false);
      return;
    }

    let isSubscribed = true;
    setIsLoading(true);

    const service = new GeneralInfoService();
    service
      .readFullName(username)
      .then((res: string) => {
        if (isSubscribed) {
          setFullName(res);
          setIsLoading(false);
        }
      })
      .catch((err: unknown) => {
        if (isSubscribed) {
          console.error("Failed to fetch full name:", err);
          setFullName(username); // Fallback to raw username
          setError(err);
          setIsLoading(false);
        }
      });

    return () => {
      isSubscribed = false;
    };
  }, [username]);

  return { fullName, isLoading, error };
};
